"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _KeyVisual = _interopRequireDefault(require("../../../truck/common/KeyVisual"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/Button"));

var _Headline = _interopRequireDefault(require("@jobmatchme/ui/es/components/Headline"));

var _functions = require("@jobmatchme/ui/es/utils/functions");

var _reactI18next = require("react-i18next");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _External = require("@jobmatchme/routing/es/provider/External");

var SectionKeyVisual = function SectionKeyVisual() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var applicationRoutes = (0, _External.useApplicationRoutes)();
  var translateNs = 'landingpage-components:keyvisual';
  return /*#__PURE__*/_react.default.createElement(_KeyVisual.default, {
    backgroundClass: _styleModule.default.background,
    backgroundColor: "dark"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    xl: {
      size: 6,
      offset: 3
    },
    md: {
      size: 12,
      offset: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_Headline.default, {
    className: _styleModule.default.headline,
    center: true,
    size: 1,
    color: "white"
  }, /*#__PURE__*/_react.default.createElement("span", null, t("".concat(translateNs, ".headline")))))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement("h2", {
    className: _styleModule.default.subheader
  }, t("".concat(translateNs, ".subheader"))))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: _styleModule.default.ctaSection
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: _styleModule.default.subheader
  }, t("".concat(translateNs, ".subheader2"))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Button.default, {
    id: "cta-pc-landingpage",
    color: "light",
    size: "large",
    variant: "raised",
    link: applicationRoutes.pcfunnel,
    title: "Job suchen",
    className: _styleModule.default.BlueButton
  }, t("".concat(translateNs, ".calltoaction"))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    className: _styleModule.default.smallLine
  }, "\xA0"))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "white",
    size: "large",
    variant: "outlined",
    title: "Anmelden",
    external: true,
    link: "https://".concat(process.env.RAZZLE_STAGE === 'prod' ? 'www' : process.env.RAZZLE_STAGE, ".jobmatch.me/").concat((0, _functions.getLocale)(), "/login/"),
    className: _styleModule.default.Button
  }, t("".concat(translateNs, ".login.button"))))))));
};

var _default = /*#__PURE__*/_react.default.memo(SectionKeyVisual);

exports.default = _default;